import { useState } from "react";
import { Link } from "react-router-dom";
import { Register } from "../api";

export default function RegisterPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const response = await Register({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
      });

      console.log(response.data);

      alert("Registration Successful");

      setFormData({
        name: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.log(error);

      alert(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
 <div className="md:min-h-screen bg-gray-100 px-4 pt-6 pb-8 md:flex md:items-center md:justify-center">
  <div className="w-full max-w-md mx-auto bg-white rounded-2xl shadow-lg p-5 sm:p-6 md:p-8">
    {/* Header */}
    <div className="text-center mb-6 sm:mb-8">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
        Create Account
      </h1>

      <p className="text-sm sm:text-base text-gray-500 mt-2">
        Register to get started
      </p>
    </div>

    <form onSubmit={handleSubmit}>
      <div className="mb-4">
        <label className="block mb-2 text-sm sm:text-base text-gray-700">
          Full Name
        </label>

        <input
          type="text"
          name="name"
          placeholder="John Doe"
          value={formData.name}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
      </div>

      <div className="mb-4">
        <label className="block mb-2 text-sm sm:text-base text-gray-700">
          Email Address
        </label>

        <input
          type="email"
          name="email"
          placeholder="john@example.com"
          value={formData.email}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
      </div>

      <div className="mb-4">
        <label className="block mb-2 text-sm sm:text-base text-gray-700">
          Phone Number
        </label>

        <input
          type="text"
          name="phone"
          placeholder="9876543210"
          value={formData.phone}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
      </div>

      <div className="mb-4">
        <label className="block mb-2 text-sm sm:text-base text-gray-700">
          Password
        </label>

        <input
          type="password"
          name="password"
          placeholder="********"
          value={formData.password}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
      </div>

      <div className="mb-6">
        <label className="block mb-2 text-sm sm:text-base text-gray-700">
          Confirm Password
        </label>

        <input
          type="password"
          name="confirmPassword"
          placeholder="********"
          value={formData.confirmPassword}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
      </div>

      <button
        type="submit"
        className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-medium transition"
      >
        Create Account
      </button>
    </form>

    <p className="text-center text-sm sm:text-base text-gray-600 mt-6">
      Already have an account?{" "}
      <Link
        to="/login"
        className="text-green-600 font-medium hover:underline"
      >
        Login
      </Link>
    </p>
  </div>
</div>
  );
}
